import { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import {
  getCryptoPaymentSettings,
  updateCryptoPaymentSettings,
} from "../api/adminPaymentSettingsApi";

export default function PaymentSettingsPage() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [enabled, setEnabled] = useState(false);
  const [receiverWalletAddress, setReceiverWalletAddress] = useState("");
  const [integrationId, setIntegrationId] = useState("");

  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const load = async () => {
    try {
      setLoading(true);

      const res = await getCryptoPaymentSettings();
      const settings = res?.settings;

      if (settings) {
        setEnabled(Boolean(settings.enabled));
        setReceiverWalletAddress(settings.receiver_wallet_address || "");
        setIntegrationId(settings.integration_id || "");
      }
    } catch (err: any) {
      setError(
        err?.response?.data?.error ||
          "Failed to load crypto payment settings."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleSave = async () => {
    try {
      setSaving(true);
      setError("");
      setSuccess("");

      await updateCryptoPaymentSettings({
        enabled,
        receiver_wallet_address: receiverWalletAddress,
        integration_id: integrationId,
      });

      setSuccess("Crypto payment settings updated.");
    } catch (err: any) {
      setError(
        err?.response?.data?.error ||
          "Failed to save crypto payment settings."
      );
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box p={3}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box p={3}>
      <Stack spacing={3} maxWidth={700}>
        <Box>
          <Typography variant="h5" fontWeight={800}>
            Payment Settings
          </Typography>

          <Typography color="text.secondary">
            Configure crypto payment processing for checkout.
          </Typography>
        </Box>

        {error && <Alert severity="error">{error}</Alert>}

        {success && <Alert severity="success">{success}</Alert>}

        <Card>
          <CardContent>
            <Stack spacing={3}>
              <Typography variant="h6" fontWeight={700}>
                DePay Crypto Payments
              </Typography>

              <FormControlLabel
                control={
                  <Switch
                    checked={enabled}
                    onChange={(e) => setEnabled(e.target.checked)}
                  />
                }
                label="Enable crypto payments"
              />

              <TextField
                label="(ETHEREUM) Receiver Wallet Address"
                value={receiverWalletAddress}
                onChange={(e) =>
                  setReceiverWalletAddress(e.target.value)
                }
                fullWidth
              />

              <TextField
                label="DePay Integration ID"
                value={integrationId}
                onChange={(e) => setIntegrationId(e.target.value)}
                fullWidth
              />

              <Button
                variant="contained"
                onClick={handleSave}
                disabled={saving}
              >
                {saving ? (
                  <CircularProgress size={22} />
                ) : (
                  "Save Payment Settings"
                )}
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
    </Box>
  );
}